import styled from "styled-components";
import { media } from "../styles/breakpoints";

const OrientationWrapper = styled.div`
  position: fixed;
  z-index: 21;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  backdrop-filter: blur(40px);
  background-color: #00000050;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2dvh;
  display: none;

  ${media.portrait`
    display: flex;
  `}
`;

const TitleText = styled.div`
  font-family: "AlphaCentauri", sans-serif;
  color: white;
  font-size: 40px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  line-height: 0.9;
  letter-spacing: 1vw;
`;

const RotateText = styled.div`
  color: white;
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  opacity: 0.5;
`;

export default function MobileOrientation() {
  return (
    <OrientationWrapper>
      <TitleText>
        Light <br /> Voyagers
      </TitleText>
      <RotateText>Rotate device to play</RotateText>
    </OrientationWrapper>
  );
}
